<template>
    <div class="search-product">
        <p class="search-count">找到{{goods_count}}条搜索结果</p>
        <product></product>

    </div>
</template>
<script>
    import product from './Common/ProductItem.vue'

    export default {
        data () {
            return {
                goods_count: ''
            }
        },
        components: {
            product
        },
        methods: {
            get_count () {
                this.goods_count = this.Local.get('goods_count')
            }
        },
        mounted () {
            this.get_count()
        }
    }
</script>
<style scoped lang="scss">
    .search-count {
        font-size: 14px;
        color: #99A9BF;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// Product.vue?5aaf6903